<template>
    <div>
        <div class="card">
            <div class="card-header animated fadeInRightBig" >
                <div class="card-title">Usuário</div>      
            </div>
            <div class="card-body">
                <div class="row mb-4">
                    <div class="col-md-4">
                        <label><span class="required">*</span> Usuário:</label>
                        <select class='form-control' v-model="aditionalHour.user_id">
                                <option :value="user.id" v-for="user in users" :key="user.id">{{ user.name }}</option>
                            </select>
                    </div>
                    <div class="col-md-4">
                        <label><span class="required">*</span> Tempo</label>
                        <input type="text" class="form-control" v-model="aditionalHour.time" v-mask="'##:##:##'" placeholder="HH:MM:SS">
                    </div>
                    <div class="col-md-4">
                        <label><span class="required">*</span> Tipo</label>
                        <select class='form-control' v-model="aditionalHour.type">
                            <option value="Acrescimo">Acrescimo</option>
                            <option value="Decréscimo">Decréscimo</option>
                        </select>
                    </div>
                </div>
                <div class="block text-right">
                    <router-link to="/aditionalHours" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <p><span class="required">*</span> Campos Obrigatórios</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                users: [],
                aditionalHour: {
                    user_id: '',
                    time: '',
                    type: 'Acrescimo'
                }
            }
        },
        methods: {
            save: function () {
                const self = this;

                if(self.aditionalHour.id) return self.edit();

                const api = this.$store.state.api + 'aditionalHours';

                let fd = self.makeFormData();
                if(!fd) return;

                self.$http.post(api, fd)
                    .then((response) => {
                        self.$message('Sucesso', `Hora adicional cadastrada com sucesso`, 'success');
                        this.$router.push('/aditionalHours');
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
            edit: function () {
                const self = this;
                const api = self.$store.state.api + 'aditionalHours/' + self.aditionalHour.id;

                let fd = self.makeFormData();
                if(!fd) return;

                self.$http.post(api, fd)
                    .then((response) => {
                        self.$message('Sucesso', `Hora adicional cadastrada com sucesso`, 'success');
                        this.$router.push('/aditionalHours');
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
            makeFormData: function(){
                const self = this;

                let fd  = new FormData();

                if(!self.aditionalHour.time || self.aditionalHour.time.length < 8){
                    self.$message('Erro', 'Preencha horas válidas', 'error');
                    return false;
                }

                var hms = self.aditionalHour.time.split(':'); 
                var miliseconds = ((+hms[0]) * 60 * 60 + (+hms[1]) * 60 + (+hms[2])) * 1000; 

                fd.append('user_id', self.aditionalHour.user_id);
                fd.append('miliseconds', self.aditionalHour.type == 'Acrescimo' ? miliseconds : miliseconds * -1);

                if(self.aditionalHour.id) {
                    fd.append('id', self.aditionalHour.id);
                    fd.append('_method', 'PUT');
                }

                return fd;
            },
            getUsers: function(){
                const self = this;
                const api = this.$store.state.api + 'users?paginated=false';

                self.$http.get(api)
                    .then((response) => {
                        self.users = response.data.data;
                    })
                    .catch((error) => {
                        self.$message('Erro', error.response.data, 'error');
                    });
            },
            msToTime: function(duration) {
                var milliseconds = parseInt((duration % 1000) / 100),
                    seconds = Math.floor((duration / 1000) % 60),
                    minutes = Math.floor((duration / (1000 * 60)) % 60),
                    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

                hours = (hours < 10) ? "0" + hours : hours;
                minutes = (minutes < 10) ? "0" + minutes : minutes;
                seconds = (seconds < 10) ? "0" + seconds : seconds;

                return hours + ":" + minutes + ":" + seconds;
            },
            getAditionalHour: function(id){
                let self = this;
                let api  = self.$store.state.api + 'aditionalHours/' + id;

                self.$http.get(api)
                    .then((response) => {
                        let aditionalHour = response.data.data[0];
                        aditionalHour.time = self.msToTime(aditionalHour.miliseconds)
                        self.aditionalHour = aditionalHour
                    })
                    .catch((error) => {
                        self.errors = error.response.data;
                        self.$message(null, self.errors, 'error');
                    });
            },
        },
        mounted: function(){
            const self = this;

            self.getUsers();

            let id = self.$route.params.id;
            if(id) {
                self.getAditionalHour(id);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AditionalHour/Add.vue